/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Challenge_FocusInputs */

const en_onboarding_challenge_focus = /** @type {(inputs: Onboarding_Challenge_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintaining focus`)
};

const es_onboarding_challenge_focus = /** @type {(inputs: Onboarding_Challenge_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantener la concentración`)
};

/**
* | output |
* | --- |
* | "Maintaining focus" |
*
* @param {Onboarding_Challenge_FocusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_challenge_focus = /** @type {((inputs?: Onboarding_Challenge_FocusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Challenge_FocusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_challenge_focus(inputs)
	return en_onboarding_challenge_focus(inputs)
});